function swymCallbackFn(swat) {
  // Checks 
  function checkExists() {

    document.addEventListener('swym:collections-loaded', function () {
      swat.initializeActionButtons('.boost-pfs-filter-products');
    });

    document.addEventListener('swym:cart-loaded', function () {
      swat.initializeActionButtons('.basket-recommendations__products');
    });

    const buttons = document.querySelectorAll(".js-wishlist-button");

    // Add/remove active classes to each wishlist button
    buttons.forEach(button => {
      window._swat.fetch(function (items) {
        if (items.length > 0) {
          for (var i = 0; i < items.length; i++) {
            if (items[i].epi == button.getAttribute('data-wl-epi')) {
              button.classList.add("is-added");
              break;
            } else {
              button.classList.remove("is-added");
            }
          }
        } else {
          // If no matches are found, remove any remaining active wishlist buttons
          button.classList.remove("is-added");
        }
      });
    });
  }

  checkExists();

  window.addEventListener('wishlist-check', function () {
    checkExists();
  })
}
if (!window.SwymCallbacks) {
  window.SwymCallbacks = [];
}
window.SwymCallbacks.push(swymCallbackFn);